/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* ==========================================================================
   Google Analytics 4 (gtag.js) + element-level engagement tracking
   Measurement ID: G-746VFW8063
   - Base tag fires page_view on every storefront page.
   - Homepage: hero banner clicks (select_promotion) + section product clicks
     (select_item, item_list_name = "Home: <collection>").
   - Collection pages (incl. creator pages and All Products): view_item_list on
     load + product clicks (select_item), item_list_name = "Collection: <handle>".
     This lets you compare creators by list views -> product clicks -> purchase.
   NOTE: purchase/checkout events are captured via Settings > Customer events
   (separate GA4 pixel), not here.
   ========================================================================== */
(function () {
  var GA_MEASUREMENT_ID = 'G-746VFW8063';

  // --- Load gtag.js ---------------------------------------------------------
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_MEASUREMENT_ID;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);

  function productHandleFrom(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // --- Homepage element tracking -------------------------------------------
  function initHomepageTracking() {
    var body = document.body;
    if (!body || body.className.indexOf('template-index') === -1) return;
    var main = document.getElementById('main');
    if (!main || typeof gtag !== 'function') return;

    main.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';

      // Product click from a homepage collection row
      var prodHandle = productHandleFrom(href);
      var prodColl = href.match(/\/collections\/([^\/]+)\/products\//);
      if (prodHandle && prodColl) {
        var listName = 'Home: ' + prodColl[1];
        gtag('event', 'select_item', {
          item_list_id: 'home_' + prodColl[1],
          item_list_name: listName,
          items: [{ item_id: prodHandle, item_name: prodHandle, item_list_name: listName }]
        });
        return;
      }

      // Collection-level link (no /products/)
      var coll = href.match(/\/collections\/([^\/?#]+)(?:[\/?#]|$)/);
      if (coll) {
        var isHeroBanner = a.classList.contains('home-carousel--image_link') ||
                           !!a.closest('[data-section-type="home-carousel"]');
        gtag('event', 'select_promotion', {
          promotion_id: (isHeroBanner ? 'hero_' : 'home_link_') + coll[1],
          promotion_name: (isHeroBanner ? 'Hero banner: ' : 'Home link: ') + coll[1],
          creative_slot: isHeroBanner ? 'homepage_hero' : 'homepage_link',
          location_id: 'homepage'
        });
      }
    }, true);
  }

  // --- Collection-page tracking (creators, All Products, etc.) --------------
  function initCollectionTracking() {
    var body = document.body;
    if (!body || body.className.indexOf('template-collection') === -1) return;
    if (typeof gtag !== 'function') return;

    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var listName = 'Collection: ' + handle;
    var main = document.getElementById('main');

    // view_item_list on load (scrape product handles currently on the page)
    var items = [];
    if (main) {
      var links = main.querySelectorAll('a[href*="/products/"]');
      var seen = {};
      for (var i = 0; i < links.length && items.length < 50; i++) {
        var ph = productHandleFrom(links[i].getAttribute('href'));
        if (ph && !seen[ph]) {
          seen[ph] = 1;
          items.push({ item_id: ph, item_name: ph, item_list_name: listName });
        }
      }
    }
    gtag('event', 'view_item_list', {
      item_list_id: 'collection_' + handle,
      item_list_name: listName,
      items: items
    });

    // product clicks on this collection page
    if (main) {
      main.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
        if (!a) return;
        var ph = productHandleFrom(a.getAttribute('href'));
        if (ph) {
          gtag('event', 'select_item', {
            item_list_id: 'collection_' + handle,
            item_list_name: listName,
            items: [{ item_id: ph, item_name: ph, item_list_name: listName }]
          });
        }
      }, true);
    }
  }

  function init() {
    initHomepageTracking();
    initCollectionTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
